<div *ngIf="!orderType" class="card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Order Type</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideAdd]="false"
				[hideCancel]="true"
				[hideDelete]="true"
				[hideSave]="true"
				(onAddChange)="orderTypeAdd()"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>

	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="venueSvc.ooOrderTypes"
		[paginator]="venueSvc.ooOrderTypes && venueSvc.ooOrderTypes.length > 10"
		[rows]="10"
		[showCurrentPageReport]="true"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50]"
		[globalFilterFields]="['displayName', 'posName']"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<span class="p-float-label p-input-icon-left m-2 flex-grow-1">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search by name or display name</label>
				</span>
			</div>
		</ng-template>
		<ng-template pTemplate="header" #header>
			<tr>
				<th>Name</th>
				<th>POS Name</th>
				<th>Active</th>
				<th>Delivery</th>
				<th>@table</th>
				<th>Future Order</th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" #body let-rec let-idx="rowIndex">
			<tr (click)="orderType = rec">
				<td>{{ rec.displayName }}</td>
				<td>{{ rec.posName }}</td>
				<td>
					<fa-icon *ngIf="rec.active" [icon]="['far', 'check']"></fa-icon>
					<fa-icon *ngIf="!rec.active" [icon]="['far', 'times']"></fa-icon>
				</td>
				<td>
					<fa-icon *ngIf="rec.isDelivery" [icon]="['far', 'check']"></fa-icon>
				</td>
				<td>
					<fa-icon *ngIf="rec.atTable" [icon]="['far', 'check']"></fa-icon>
				</td>
				<td>
					<fa-icon *ngIf="rec.futureOrder" [icon]="['far', 'check']"></fa-icon>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<app-order-type-record-setup *ngIf="orderType" [(orderType)]="orderType"> </app-order-type-record-setup>
